import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Form } from '@ant-design/compatible';

import { message } from 'antd';
import { LOGIN_CHANGE } from 'actions';
import { Cognito } from '@xbcb/aws-utils';
import inltLogin from 'libs/inltLogin';
// import reportError from 'libs/reportError';
import VerificationForm from './component';

const mapStateToProps = (state) => ({
  delivery: state.ui.login.delivery,
  flow: state.ui.login.flow,
  user: state.ui.login.user,
  remember: state.ui.login.remember,
  isLoading: state.ui.login.isLoading,
});

const mapDispatchToProps = (dispatch, { form, location, history }) => ({
  submit: ({ e, flow, delivery, user, remember }) => {
    e.preventDefault();
    dispatch(LOGIN_CHANGE({ isLoading: true }));
    form.validateFields(async (err, values) => {
      if (err) {
        dispatch(LOGIN_CHANGE({ isLoading: false }));
      } else if (flow === 'forgot') {
        dispatch(
          LOGIN_CHANGE({
            verificationCode: values.verificationCode,
            form: 'newPassword',
          }),
        );
        dispatch(LOGIN_CHANGE({ isLoading: false }));
      } else if (flow === 'login') {
        try {
          const totp =
            delivery.DeliveryMedium === 'TOTP' ? 'SOFTWARE_TOKEN_MFA' : '';
          const response = await Cognito.sendMFACode(
            user,
            values.verificationCode,
            totp,
          );
          if (typeof response === 'string') {
            await inltLogin({
              dispatch,
              location,
              history,
              remember,
              userToken: response,
            });
          }
          dispatch(LOGIN_CHANGE({ isLoading: false }));
        } catch (e) {
          let msg = e.message;
          if (e.code !== 'CodeMismatchException') {
            // reportError(e);
          } else {
            msg = 'Invalid code.';
          }
          message.error(msg, 3.5);
          dispatch(LOGIN_CHANGE({ isLoading: false }));
        }
      }
    });
  },
});

export default withRouter(
  Form.create()(connect(mapStateToProps, mapDispatchToProps)(VerificationForm)),
);
